// TODO: move this to the config service
export const BEACON_CHAIN_EXPLORERS = {
  '1': 'https://beaconcha.in',
  '17000': 'https://holesky.beaconcha.in',
}
